var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Target",
    clipPath: "url(#clip0_1824_4310)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 12.5L21 3.5",
    stroke: "#6A49DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3646 6.13624C16.7705 4.54588 14.6375 3.61176 12.3877 3.51868C10.1379 3.42559 7.93503 4.18032 6.21499 5.63355C4.49495 7.08679 3.38299 9.13268 3.0991 11.3665C2.8152 13.6003 3.38005 15.8593 4.6819 17.6965C5.98374 19.5338 7.92776 20.8156 10.1294 21.2882C12.331 21.7609 14.6298 21.39 16.571 20.249C18.5123 19.1079 19.9546 17.2798 20.6125 15.1263C21.2705 12.9729 21.0963 10.6509 20.1243 8.61968",
    stroke: "#6A49DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.182 9.31805C14.4376 8.57455 13.4562 8.11538 12.4084 8.02035C11.3606 7.92532 10.3126 8.20044 9.44661 8.79788C8.58059 9.39532 7.95129 10.2773 7.66807 11.2906C7.38485 12.3039 7.46562 13.3843 7.89634 14.3442C8.32706 15.3041 9.08051 16.0828 10.0257 16.5448C10.9709 17.0068 12.0482 17.1231 13.0702 16.8733C14.0922 16.6236 14.9944 16.0236 15.62 15.1777C16.2456 14.3318 16.555 13.2934 16.4945 12.243",
    stroke: "#6A49DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1824_4310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIcon);
export default __webpack_public_path__ + "static/media/targetIcon.ed9a1d06e4bc58fd3479ff78cc2606c9.svg";
export { ForwardRef as ReactComponent };